import { render, staticRenderFns } from "./DashboardOverview.vue?vue&type=template&id=0ef78478&scoped=true&"
import script from "./DashboardOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardOverview.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOverview.css?vue&type=style&index=0&id=0ef78478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef78478",
  null
  
)

export default component.exports